import { createRouter, createWebHistory } from "vue-router";
import PageNotFound from "@/components/PageNotFound.vue";
import Disclaimer from "@/components/Disclaimer.vue";
import DealListing from "@/components/DealList.vue";
import { UIM_MS_SSO_KEY } from "@/apis/user-authentication";
import { merge } from "lodash";

const routes = [
  {
    path: "/",
    component: Disclaimer,
    name: "Disclaimer",
  },
  {
    path: "/deals-listing",
    component: DealListing,
    name: "Deals Listing",
  },
  {
    path: "/:pathMatch(.*)*",
    component: PageNotFound,
    name: "Page Not Found",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // look for a UIM token in the URL
  const tokenId = to.query[UIM_MS_SSO_KEY];

  if (tokenId) {
    const currentUrl = new URL(window.location.href);
    // strip the token from the url to prevent it from being bookmarked
    currentUrl.searchParams.delete(UIM_MS_SSO_KEY);

    const newTo = merge({}, to, {
      fullPath: `${to.path}${currentUrl.search}`,
    });

    // strip the token from the new route to prevent it from being bookmarked
    delete newTo.query[UIM_MS_SSO_KEY];

    // redirect the user to their intended route
    // the route guard will then validate the cookie
    next(newTo);
  } else {
    next();
  }
});

export default router;
